import env from "flow/configuration/environment";
import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "get",
    description: "Displays a certain environment variable",
    options: [],
    arguments: [
        {
            name: "key",
            description: "The key display value for.",
            type: "string",
            mandatory: true
        }
    ],
    callback: (writer, optsAndArgs) => {
        writer.output.writeLine(env.get(optsAndArgs.key) as string);

        return { input: "" };
    }
} as ICLICommand;
